import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { term: String }

  connect() {
    document.addEventListener("turbo:frame-load", this.handleFrameLoad)
    this.highlight()
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.handleFrameLoad)
  }

  handleFrameLoad = () => {
    this.highlight()
  }

  termValueChanged() {
    this.highlight()
  }

  highlight() {
    const termString = this.termValue?.trim()
    if (!termString || termString.length < 2) return

    const terms = termString.split(/\s+/).filter(t => t.length >= 2)
    if (terms.length === 0) return

    this.element.querySelectorAll(".search-result-item").forEach(result => {
      this.highlightTextNodes(result, terms)
    })
  }

  highlightTextNodes(element, terms) {
    const termsKey = terms.join("|")
    if (element.dataset.highlighted === termsKey) return
    element.dataset.highlighted = termsKey

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: (node) => {
          // Skip empty text nodes and nodes inside already-highlighted spans
          if (!node.textContent.trim()) return NodeFilter.FILTER_REJECT
          if (node.parentElement?.dataset.searchHighlight) return NodeFilter.FILTER_REJECT
          return NodeFilter.FILTER_ACCEPT
        }
      }
    )

    const nodesToProcess = []
    let node
    while (node = walker.nextNode()) {
      const lowerText = node.textContent.toLowerCase()
      if (terms.some(term => lowerText.includes(term.toLowerCase()))) {
        nodesToProcess.push(node)
      }
    }

    // Build regex that matches any of the terms
    const pattern = terms.map(t => this.escapeRegExp(t)).join("|")
    const regex = new RegExp(`(${pattern})`, "gi")

    nodesToProcess.forEach(textNode => {
      const text = textNode.textContent
      const parts = text.split(regex)

      if (parts.length === 1) return

      const fragment = document.createDocumentFragment()
      parts.forEach(part => {
        const isMatch = terms.some(term => part.toLowerCase() === term.toLowerCase())
        if (isMatch) {
          const span = document.createElement("span")
          span.className = "font-bold text-warm-gray-800"
          span.dataset.searchHighlight = "true"
          span.textContent = part
          fragment.appendChild(span)
        } else if (part) {
          fragment.appendChild(document.createTextNode(part))
        }
      })

      textNode.parentNode.replaceChild(fragment, textNode)
    })
  }

  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }
}
